import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "../Reveal";
import { useT } from "../../i18n/I18nProvider";

export const HomeFinalCta = () => {
  const t = useT();

  return (
    <section className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 pb-16">
      <Reveal className="relative overflow-hidden rounded-md border border-ink-200 bg-paper p-8 md:p-16">
        <div className="grid lg:grid-cols-12 gap-6 md:gap-8 items-center">
          <div className="lg:col-span-8">
            <div className="overline mb-3 md:mb-4">
              {t("home.finalCta.overline")}
            </div>
            <h3 className="font-display text-3xl sm:text-4xl md:text-6xl tracking-tightest leading-[0.95]">
              {t("home.finalCta.title1")}
              <br />
              <span className="font-editorial text-ink-700">
                {t("home.finalCta.titleEditorial")}
              </span>
            </h3>
          </div>
          <div className="lg:col-span-4 lg:justify-self-end">
            <Link to="/contatti" className="btn-pill" data-testid="home-cta-final">
              {t("home.finalCta.button")}
              <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.6} />
            </Link>
          </div>
        </div>
      </Reveal>
    </section>
  );
};
